module.exports = __webpack_public_path__ + "img/IC_Ausencia_Pendiente.c36c5ad8.svg";